export default __webpack_public_path__ + "static/media/odm-logo.c7907f7c.png";